import { logError } from 'calling-integration-sdk-support/utils/logError';
export const getParentWindow = () => {
  if (window.location.origin === window.parent.location.origin) {
    try {
      var _parentWindow$hubspot;
      const parentWindow = window.parent.window;
      // Accessing any object in the parent window will throw an error if the parent window is not accessible
      // only same-origin parent windows are accessible
      if ((_parentWindow$hubspot = parentWindow.hubspot) !== null && _parentWindow$hubspot !== void 0 && _parentWindow$hubspot.zorse) {
        return parentWindow;
      }
      return null;
    } catch (e) {
      var _hrefParam$includes;
      const searchParams = new URLSearchParams(window.location.search);
      const hrefParam = searchParams.get('href');
      const isLocalPresent = (_hrefParam$includes = hrefParam === null || hrefParam === void 0 ? void 0 : hrefParam.includes('local')) !== null && _hrefParam$includes !== void 0 ? _hrefParam$includes : false;
      if (e instanceof Error && !isLocalPresent) {
        logError('Error accessing parent window', {
          error: e,
          level: 'info'
        });
      } else {
        console.error(e);
      }
      return null;
    }
  }
  return null;
};